module.exports = __webpack_public_path__ + "img/hdlog1.134931b4.png";